(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-nutshell-toc]').forEach((toc) => {
      if (toc.dataset.initialized === 'true') return;

      const section = toc.closest('.article-single');
      const content = section?.querySelector('.article__content');
      const links = Array.from(toc.querySelectorAll('.nutshell-article-toc__link'));
      const headings = Array.from(content?.querySelectorAll('h2') || []);
      const list = toc.querySelector('[data-nutshell-toc-list]');
      const toggle = toc.querySelector('[data-nutshell-toc-toggle]');

      if (!content || links.length === 0 || headings.length === 0) {
        toc.hidden = true;
        return;
      }

      toc.dataset.initialized = 'true';

      links.forEach((link, index) => {
        const heading = headings[index];
        if (!heading) {
          link.closest('li')?.remove();
          return;
        }

        const anchor = link.getAttribute('href')?.slice(1);
        if (anchor) heading.id = anchor;
      });

      const availableLinks = links.filter((link) => document.getElementById(link.getAttribute('href')?.slice(1)));
      const linkById = new Map(availableLinks.map((link) => [link.getAttribute('href').slice(1), link]));

      const instance = toc.dataset.tocInstance;
      const previewLimit = instance === 'stacked' ? 3 : 5;
      const shouldCollapse = availableLinks.length > previewLimit;

      if (shouldCollapse && list && toggle) {
        const setExpanded = (expanded) => {
          toc.classList.toggle('is-expanded', expanded);
          toggle.setAttribute('aria-expanded', String(expanded));
        };

        const hashId = window.location.hash.slice(1);
        const hashIndex = availableLinks.findIndex((link) => link.getAttribute('href') === `#${hashId}`);
        const startsExpanded = hashIndex >= previewLimit;

        toc.classList.add('is-collapsible');
        toggle.hidden = false;
        setExpanded(startsExpanded);

        toggle.addEventListener('click', () => {
          setExpanded(toggle.getAttribute('aria-expanded') !== 'true');
        });
      }

      const setActive = (id) => {
        availableLinks.forEach((link) => link.classList.toggle('is-active', linkById.get(id) === link));
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
          if (visible[0]) setActive(visible[0].target.id);
        }, { rootMargin: '-15% 0px -70% 0px', threshold: 0 });

        headings.slice(0, availableLinks.length).forEach((heading) => observer.observe(heading));
      }
    });
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
